import * as z from 'zod';

import { validateDuplicateCPFs } from '../../../../utils/validateUniqueCpf';
import { schema } from './';

export const creditCardSchema = z
  .object({
    payment: z.optional(
      z.object({
        number: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
        name: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
        /* cpf: z.optional(
        z
          .string()
          .min(14, { message: 'Requer 14 caracteres' })
          .regex(/^(?!\d{11})\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/, {
            message: 'CPF inválido',
          }),
      ), */
        expireDate: z.optional(
          z
            .string()
            .min(1, { message: 'Campo obrigatório' })
            .regex(/^\d{2}\/\d{2}$/, { message: 'Data inválida' }),
        ),
        cvv: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
        instalment: z.optional(
          z.string().min(1, { message: 'Campo obrigatório' }),
        ),
      }),
    ),

    user: schema,
  })
  .superRefine((data, ctx) => {
    const entries: { cpf?: string; path: (string | number)[] }[] = [];

    const user = data.user;

    if (user.documents?.cpf) {
      entries.push({
        cpf: user.documents.cpf,
        path: ['user', 'documents', 'cpf'],
      });
    }

    (user.dependents || []).forEach((dep, i) => {
      entries.push({
        cpf: dep.cpf,
        path: ['user', 'dependents', i, 'cpf'],
      });
    });

    validateDuplicateCPFs(entries, ctx);
  });

export type CreditCardSchema = z.infer<typeof creditCardSchema>;
